/** @jsxRuntime classic */
/** @jsxFrag React.Fragment */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useMemo } from 'react'

import { Button, Dialog, GhostButton, P, TableRow, TableV2 } from '@bonitour/components'
import { bold, buttonsContainer, dialogStyle, dialogTextSize, marginRight20, marginTop25, tableContainer } from './SelectedTicketsDialog.style'
import { identity } from '@bonitour/common-functions'
import { TicketStatusTableCell, TicketTableCell } from 'domains/Ticket/CheckIn/TicketList'
import { formatISOTime } from 'utils/time'

const tableMobileBreakpoint = Number.MAX_SAFE_INTEGER

export const SelectedTicketsDialog = ({
  isVisible = false,
  quantity = 0,
  onCloseDialog = identity,
  onSubmitValidation = identity,
  ticketsDetails = []
}) => {
  const ticketWord = quantity > 1 ? 'ingressos' : 'ingresso'

  const hidePaymentStatus = !ticketsDetails?.some(({ paymentStatus }) => Boolean(paymentStatus))
  const ticketColumnsLabels = useMemo(
    () => ['Cliente', 'Data e hora', 'Tipo', 'Serviço', 'Status'].concat(hidePaymentStatus ? [] : ['Pagamento']),
    [hidePaymentStatus]
  )

  return (
    <Dialog
      isVisible={isVisible}
      title='Confirmação de utilização'
      customContainercss={dialogStyle}
      onClose={onCloseDialog}
    >
      <P css={[dialogTextSize, marginTop25]}>Você está prestes a utilizar <span css={bold}>{`${quantity}`}</span> {`${ticketWord}`}, <span css={bold}>e essa ação não poderá ser alterada depois.</span> Gostaria de prosseguir com a utilização dos ingressos?</P>

      <TableV2
        labels={ticketColumnsLabels}
        mobileBreakpoint={tableMobileBreakpoint}
        customCss={tableContainer}
      >
        {ticketsDetails?.map((ticket) => (
          <TableRow key={`ticket-${ticket.id}`}>
            {[
              <TicketTableCell fontSize='small' maxLines={3} key='client'>
                {ticket.client || ticket.passengerName}
              </TicketTableCell>,

              <TicketTableCell maxLines={3} key='slot'>
                <>{formatISOTime(ticket.day, 'DD/MM/YYYY', false)} {ticket.hour || ticket.time}</>
              </TicketTableCell>,
              <TicketTableCell maxLines={4} key='type'>
                {ticket.type || ticket.paxType}
              </TicketTableCell>,
              <TicketTableCell maxLines={2} key='company+service'>
                {ticket.company}
                <strong>{ticket.activity || ticket.serviceName}</strong>
                {ticket.pickup ? `Embarque: ${ticket.pickup}` : null}
              </TicketTableCell>,
              <TicketStatusTableCell status={ticket.state} key='status' />,
              <TicketStatusTableCell status={ticket.paymentStatus} key='payment' />
            ]}
          </TableRow>
        ))}
      </TableV2>

      <div css={[buttonsContainer, marginTop25]}>
        <GhostButton css={marginRight20} onClick={onCloseDialog}>Cancelar</GhostButton>
        <Button onClick={onSubmitValidation}>Confirmar utilização</Button>
      </div>
    </Dialog>
  )
}
